import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {TokenDataProviderService} from "../services/token-data-provider.service";
import {ResponseNotificationService} from "../services/response-notification.service";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class CompleteRegistrationGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly ts: TokenDataProviderService,
    private readonly rns: ResponseNotificationService,
    private readonly translate: TranslateService
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.ts.requiresRegistrationCompletion()) {
      return true;
    }

    this.rns.emitError(this.translate.instant('app.error.api_forbidden'));
    this.router.navigate(['/']);

    return false;
  }
}
